$ = jQuery;
$(document).ready(function () {

	function getCookie(cname) {
		let name = cname + "=";
		let decodedCookie = decodeURIComponent(document.cookie);
		let ca = decodedCookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}
	var downlaodPopupEle = jQuery('#downloadAppPopup'),
		closeBtn = jQuery('#downloadAppPopup .closeData');
	if (getCookie('app_download') == '') {
		jQuery(downlaodPopupEle).fadeIn(300);
	}
	jQuery(closeBtn).click(function () {
		jQuery(downlaodPopupEle).fadeOut(300);
		const d = new Date();
		d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000));
		let expires = "expires=" + d.toUTCString();
		document.cookie = "app_download=1;" + expires + ";path=/";
	})

	// pdp sticky btn
	if (window.innerWidth <= 767) {
		$(document).on('click', '.stikcy-atc-wrapper .btn', function () {
			$('.btn[name="checkout"],#add-to-cart-form [type="submit"]').trigger('click');
		})
		var btnText = '';
		(__st.p == 'product') ? btnText = "Add To Cart" : btnText = "Proceed to Checkout";
		var pdpBtnClone = `<div class="stikcy-atc-wrapper" style="display:none;"><button type="button" class="btn btn-primary">${btnText}</button></div>`;
		$('body').append(pdpBtnClone);
		$(window).scroll(function () {
			const atcBtn = $('.template-product .btn[name="checkout"],#add-to-cart-form [type="submit"]');
			if (atcBtn) {
				var scroll = $(window).scrollTop(),
					atcBtnOffset = atcBtn.offset().top + 60;
				if (scroll >= atcBtnOffset) {
					$('.stikcy-atc-wrapper').fadeIn();
					$('#downloadAppPopup').css('bottom', $('.stikcy-atc-wrapper').height());
					// if ($('#downloadAppPopup').is(':visible')) {
					//     $('#ba-loy-container #launcher-wrapper').css('bottom', '180px');
					// } else {
					//     $('#ba-loy-container #launcher-wrapper').css('bottom', '70px');
					// }
				} else {
					$('.stikcy-atc-wrapper').fadeOut();
					$('#downloadAppPopup').css('bottom', '0');
					$('#ba-loy-container #launcher-wrapper').removeAttr('style');
					// if ($('#downloadAppPopup').is(':visible')) {
					//     $('#ba-loy-container #launcher-wrapper').css('bottom', '130px');
					// } else {
					//     $('#ba-loy-container #launcher-wrapper').css('bottom', '30px');
					// } 
				}
			}
		})
	}

	// search auto complete
	$(function () {
		// Current Ajax request.
		var currentAjaxRequest = null;
		// Grabbing all search forms on the page, and adding a .search-results list to each.
		var searchForms = $('form[action="/search"]').css('position', 'relative').each(function () {
			// Grabbing text input.
			var input = $(this).find('input[name="q"]');
			// Adding a list for showing search results.
			var offSet = input.position().top + input.innerHeight();
			$('<ul class="search-results"></ul>').css({ 'position': 'absolute', 'left': '0px', 'top': offSet }).appendTo($(this)).hide();
			// Listening to keyup and change on the text field within these search forms.
			input.attr('autocomplete', 'off').bind('keyup change', function () {

				// What's the search term?
				var term = $(this).val();
				// What's the search form?
				var form = $(this).closest('form');
				// What's the search URL?
				var searchURL = '/search?type=product&q=' + term;
				// What's the search results list?
				var resultsList = form.find('.search-results');
				// If that's a new term and it contains at least 3 characters.
				if (term.length > 3 && term == $(this).attr('data-old-term')) {
					// Saving old query.
					$(this).attr('data-old-term', term);
					// Killing any Ajax request that's currently being processed.
					if (currentAjaxRequest != null) currentAjaxRequest.abort();
					// Pulling results.
					currentAjaxRequest = $.getJSON(searchURL + '&view=json', function (data) {
						// Reset results.
						resultsList.empty();
						// If we have no results.
						if (data.results_count == 0) {
							// resultsList.html('<li><span class="title">No results.</span></li>');
							// resultsList.fadeIn(200);
							resultsList.hide();
						} else {
							console.log(data);
							// If we have results.
							$.each(data.results, function (index, item) {
								if ($.inArray('hidden', item.tags) == -1 && $.inArray('HideProduct', item.tags) == -1) {
									var link = $('<a></a>').attr('href', item.url);
									link.append('<span class="thumbnail"><img src="' + item.thumbnail + '" /></span>');
									link.append('<span class="title">' + item.title + '</span>');
									link.wrap('<li></li>');
									resultsList.append(link.parent());
								}
							});
							// The Ajax request will return at the most 10 results.
							// If there are more than 10, let's link to the search results page.
							if (data.results_count > 10) {
								resultsList.append('<li><span class="title"><a href="' + searchURL + '">See all results (' + data.results_count + ')</a></span></li>');
							}
							resultsList.fadeIn(200);
						}
					});
				}
			});
		});
		// Clicking outside makes the results disappear.
		$('body').bind('click', function () {
			$('.search-results').hide();
		});
	});

	if (typeof (window.el.headSticky) != 'undefined') {
		window.el.headSticky();
	}
	if (typeof (window.el.plpalt_recentOwl) != 'undefined') {
		window.el.plpalt_recentOwl();
	}
	if (typeof (window.el.plp_recentOwl) != 'undefined') {
		window.el.plp_recentOwl();
	}
	if (typeof (window.el.page_custom_6_recentOwl) != 'undefined') {
		window.el.page_custom_6_recentOwl();
	}
	if (typeof (window.el.page_custom_10_recentOwl) != 'undefined') {
		window.el.page_custom_10_recentOwl();
	}
	if (typeof (window.el.page_custom_12_recentOwl) != 'undefined') {
		window.el.page_custom_12_recentOwl();
	}
	if (typeof (window.el.pagetest_recentOwl) != 'undefined') {
		window.el.pagetest_recentOwl();
	}
})

// Bulk order
document.addEventListener('DOMContentLoaded', () => {
	// const corporate_btn = document.querySelector(".desktop-pdp-custom-corprate-button");
  //   if (corporate_btn){
  //       corporate_btn.addEventListener("click", function (event) {
  //           event.preventDefault(); 
  //           document.querySelector('.popup_bulk_container').classList.add('active');
  //           document.body.classList.add('overlay_bulkpopup');
  //       });
  //   }

  //   const close_up_btn = document.querySelector(".close_popup");
  //   if(close_up_btn){
  //       close_up_btn.addEventListener("click", function (event) {
  //           event.preventDefault(); 
  //           document.querySelector('.popup_bulk_container').classList.remove('active');
  //           document.body.classList.remove('overlay_bulkpopup');
  //       });
  //   }

	// 	let thankyouMessage = document.querySelector('#thank_you');
	// 	const productForm = document.querySelector('#ContactForm-product-template');
	// 	// const bulkPage = document.querySelector('#ContactForm-bulk-order');
	// 	if (productForm) {
	// 		productForm.addEventListener('submit',function (event) {
	// 			event.preventDefault();
	// 			const formSubmittedSuccessfully = true;
	// 			if (formSubmittedSuccessfully) {
	// 				productForm.style.display = 'none';
	// 				thankyouMessage.style.display = 'block';
	// 			}
	// 		});
	// 	}
		// if (bulkPage) {
		// 	bulkPage.addEventListener('submit',function (event) {
		// 		event.preventDefault();
		// 		const formSubmittedSuccessfully = true;
		// 		if (formSubmittedSuccessfully) {
		// 			bulkPage.style.display = 'none';
		// 			thankyouMessage.style.display = 'block';
		// 		}
		// 	});
		// }



		// new code
		const corporate_btn = document.querySelector(".desktop-pdp-custom-corprate-button"),
		bulk_form_state = document.querySelector('.bulk-form-state');
		
		if (bulk_form_state) {
			const bulkpopupContainer = document.querySelector(".popup_bulk_container"),
					close_up_btn = document.querySelector(".bulk_close_popup"),
					bulkcloseIconBtn = document.querySelector(".bulk_close_btn"),
					bulknotifySend = bulk_form_state.querySelector('#bulksendButton'),
					bulkProductForm = bulk_form_state.querySelector('#ContactForm-bulkForm');
					bulkthankYouMessage = document.getElementById('bulk_thank_you'),
					fields = bulk_form_state.querySelectorAll('input,textarea');;
		
					if(corporate_btn){
						corporate_btn.addEventListener("click", function (event) {
							event.preventDefault(); 
							bulkpopupContainer.classList.add('active');
							document.body.classList.add('overlay_bulkpopup');
						});
					}
		
			if(close_up_btn){
				close_up_btn.addEventListener("click", function (event) {
					event.preventDefault(); 
					bulkpopupContainer.classList.remove('active');
					document.body.classList.remove('overlay_bulkpopup');
				});
			}
		
			if(bulkcloseIconBtn){
					bulkcloseIconBtn.addEventListener("click", function(event) {
							event.preventDefault();
							bulkpopupContainer.classList.remove("active"); 
							document.body.classList.remove("overlay_bulkpopup");
							bulkProductForm.submit(); 
					});
			}
		
			fields.forEach(field => {
					field.addEventListener('blur', validateField);
			});
		
			function validateField(event) {
					const field = event.target;
					const errorSpan = field.closest('.field').querySelector('.form-err-msg');
					var errorMessage = '';
					switch (field.name) {
							case 'contact[Full Name]':
									if (field.value.trim() === '') {
											errorMessage = 'Name field is required';
									}
									break;
							case 'contact[email]':
									if (field.value.trim() === '') {
											errorMessage = 'Email field is required';
									} else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value)) {
											errorMessage = 'Invalid email address';
									}
									break;
							case 'contact[Phone Number]':
									if (field.value.trim() === '') {
											errorMessage = 'phone field is required';
									}
									else if (!/^\d{10}$/.test(field.value)) {
											errorMessage = 'Phone number must be 10 digits';
									}
									break;
							case 'contact[pincode]':
									if (field.value.trim() === '') {
											errorMessage = 'Pincode field is required';
									}  
									break;
							case 'contact[Product Required]':
									if (field.value.trim() === '') {
											errorMessage = 'Product name field is required';
									}
									break;
							case 'contact[Quantity Required]':
									if (field.value.trim() === '') {
											errorMessage = 'Quantity field is required';
									}
									else if (field.value < 5) {
											errorMessage = 'Value must be greater than or equal to 5.';
									}
									break;
							case 'contact[Reason]':
									if (field.value.trim() === '') {
											errorMessage = 'Reason field is required';
									}
									break;
							default:
									console.log('Default case');
									break;
					}
					if(errorSpan.textContent !=  null)
					{
						errorSpan.textContent = errorMessage;
					}
			}
		
			bulknotifySend.addEventListener('click', function(event) {
					event.preventDefault();
					const username = bulk_form_state.querySelector('[name="contact[Full Name]"]').value,
					fromEmail = bulk_form_state.querySelector('[name="contact[From Email ID]"]').value,
					mobile_number = bulk_form_state.querySelector('[name="contact[Phone Number]"]').value,
					email = bulk_form_state.querySelector('[name="contact[email]"]').value,
					pincode = bulk_form_state.querySelector('[name="contact[pincode]"]').value,
					productRequired = bulk_form_state.querySelector('[name="contact[Product Required]"]').value,
					qtyRequired = bulk_form_state.querySelector('[name="contact[Quantity Required]"]').value,
					targetPrice = bulk_form_state.querySelector('[name="contact[Targeted Price]"]').value,
					tentative = bulk_form_state.querySelector('[name="contact[Tentative Timeline]"]').value,
					reason = bulk_form_state.querySelector('[name="contact[Reason]"]').value;
					
					if (username.trim() === '' || mobile_number.trim() === '' || email.trim() === '' || pincode.trim() === '' || productRequired.trim() === '' || qtyRequired.trim() === '' || reason.trim() === '' ) {
					alert('Please fill out all fields');
					return false;
					}
					const emailPattern = /^[^@]+@[^@]+\.[^@]+$/;
					if (!emailPattern.test(email)) {
					alert('Please enter a valid email address');
					return false;
					}
		
					const mobilePattern = /^\d{10}$/;
					if (!mobilePattern.test(mobile_number)) {
					alert('Please enter a valid 10-digit mobile number');
					return false;
					}
		
					if (qtyRequired < 5) {
					alert('Value must be greater than or equal to 5.');
					return false;
					}
		
					bulknotifySend.classList.add('loading');
					fetch('https://cpanel.mensabrands.com/BulkOrder/public/addData', {
							method: "POST",
							headers: {
							"Accept": "application/json",
							"Content-type": "application/json",
							"Authorization": `Bearer ${window.sessionToken}`
							},
							body: JSON.stringify({
							full_name: username,
							email: email,
							phone_number: mobile_number,
							pincode: pincode,
							product_required: productRequired,
							quantity_required: qtyRequired,
							targeted_price: targetPrice,
							tentative_timelines: tentative,
							reason: reason,
							fromEmail: fromEmail
							})
					})
					.then(res => {
							setTimeout(() => {
									bulkProductForm.submit(); 
							}, 5000);
							bulkthankYouMessage.style.display = 'block';
						
							if (__st.rtyp !== 'product') {
								window.scrollTo({ top: 0, behavior: 'smooth' });
							}
							if(close_up_btn){
									close_up_btn.style.display = 'none';
							}
							bulknotifySend.classList.remove('loading');
							const parent = bulk_form_state.parentElement;
							if(parent.classList.contains('popup-scroller')){
									parent.style.display = 'none';
							}
							else{
									bulk_form_state.style.display = 'none';
							}
					})
			});
		}

});

// custom video banner element
class elVideo extends HTMLElement {
	constructor() {
		super();
		this.createHtml();
	}
	createHtml = () => {
		let imagePoster = this.dataset.poster;

		let html = `<style>el-video {display: block;}el-video video {width: 100%;}el-video .video-wrapper {position: relative;} el-video .VIDplayBtn{z-index:2;display:inline-block;position: absolute;top: 50%;transform: translate(-50%,-50%);left: 50%;}el-video .VIDplayBtn svg {width: 40px;height: 40px;}</style>
      <div class="el-video-wrapper">
        <div class="video-wrapper">
          <a href="javascript:void(0);" class="VIDplayBtn"><svg viewBox="0 0 97 97"><path d="M49.084,1.131C22.804,1.131,1.5,22.435,1.5,48.714c0,26.279,21.304,47.583,47.584,47.583c26.279,0,47.582-21.304,47.582-47.583C96.667,22.435,75.364,1.131,49.084,1.131z M38.118,62.52V34.908l25.93,13.807L38.118,62.52z"></path></svg></a>
          <video width="320" height="240" poster="${imagePoster}"></video>
        </div>
      </div>`;
		this.innerHTML = html;
		this.onClickVideooPlay();
	}
	onClickVideooPlay = () => {
		let playBtn = this.querySelector('.VIDplayBtn'),
			videoTag = this.querySelector('video'),
			videoUrl = this.dataset.video;
		playBtn.addEventListener('click', (e) => {
			videoTag.src = videoUrl;
			videoTag.setAttribute('controls', 'controls');
			videoTag.play();
			playBtn.style.display = 'none';
		})
	}
}
customElements.define('el-video', elVideo);

$(window).scroll(function () {
	if ($(this).scrollTop() > 1) {
		$(".wrapper-container .main-header-section").addClass("sticky-header");
		$(".wrapper-container .main-header-section").addClass("animation-header");
      $(".sticky-cart__form .tab-menu").addClass("sticky-header");
		$(".sticky-cart__form .tab-menu").addClass("animation-header");
	} else {
		$(".wrapper-container .main-header-section").removeClass("sticky-header");
		$(".wrapper-container .main-header-section").removeClass("animation-header");
      $(".sticky-cart__form .tab-menu").removeClass("sticky-header");
		$(".sticky-cart__form .tab-menu").removeClass("animation-header");
	}
});

$(document).ready(function () {
	$(".wrapper-top-cart button.btn-search").on("click", function () {
		if ($(".container.header-panel-bottom").hasClass("activated")) {
			$(".container.header-panel-bottom").removeClass("activated");
		} else {
			$(".container.header-panel-bottom").addClass("activated");
		}
	});

	if(window.innerWidth < 768){
		let cartBtnWrapper = document.querySelector('.checkout_container');
		if(cartBtnWrapper){
			let StikcyCartObserver = new IntersectionObserver((entries) => {
				entries.forEach(entry => {
					let cartBtn = document.querySelector('.checkout_container_inner');
					if (entry.isIntersecting) {
						cartBtn.classList.remove('is-sticky');
					} else {
						cartBtn.classList.add('is-sticky');
					}
				});
			}, {rootMargin: "0px"});
		
			StikcyCartObserver.observe(cartBtnWrapper)
		}
	}
});

function toggleDivVisibility() {
	var tglebtn = document.querySelector('.content-hidden.icon');
	var targetDiv = document.querySelector('.toggle-section');
	if (targetDiv.style.display === 'none' || targetDiv.style.display === '') {
		targetDiv.style.display = 'block';
	} else {
		targetDiv.style.display = 'none';
	}
	tglebtn.classList.toggle('open');
}

function delayedFunction() {
	setTimeout(toggleDivVisibility, 2000);
}

window.onload = delayedFunction;
